<rt-activity-subscriptions-table [types]="types" [title]="'app.subscriptions.me_v2' | translate">
  <rt-activity-subscriptions-table-row
    icon="mention"
    [title]="'app.subscriptions.events_group.note_mention_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['noteMention']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    icon="add"
    [title]="
      (hasRequisitions && abilities.viewRequisitions
        ? 'app.subscriptions.events_group.assignment_add_v3'
        : 'app.subscriptions.events_group.assignment_add_v2'
      ) | translate
    "
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="assignmentEventsGroup"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    icon="check"
    [title]="'app.subscriptions.events_group.task_due_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['taskDueToday', 'taskOverdue']"
    [notifyInfo]="true"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    icon="insert-emoticon"
    [title]="'app.subscriptions.events_group.note_reaction_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['noteReaction', 'noteReply']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
</rt-activity-subscriptions-table>
